export const ERROR_TYPE_UNIQUE_PERSON = 'unique-person';
